interface Functional {
  locale: string;
  data: Array<{ title: string; description: string; icon?: string }>;
}

export  default  class FunctionalLocale {
  public data: Array<{
    title: string;
    description: string;
    icon?: string;
  }> = [];
  public header: { title: string; description?: string } = { title: "" };
  constructor() {
    const { locale } = useI18n();
    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;

    this.header =
      titleLocales.find((item) => item.locale == locale.value)?.data ??
      titleLocales[0].data;
  }
}

const titleLocales: Array<{
  locale: string;
  data: { title: string; description?: string };
}> = [
  {
    locale: "en",
    data: {
      title: "QR Marketing <span class='down-mark-line'>Components</span>",
      description:
        "Functional components commonly used in QR code applications can be flexibly assembled to suit different needs.",
    },
  },
  {
    locale: "vi",
    data: {
      title: "Các <span class='down-mark-line'>Thành Phần</span> QR Marketing",
      description:
        "Các thành phần chức năng thường được sử dụng trong ứng dụng mã QR có thể được lắp ráp linh hoạt để phù hợp với các nhu cầu khác nhau.",
    },
  },
  {
    locale: "ja",
    data: {
      title:
        "<span class='down-mark-line'>コンポーネント</span>QRマーケティング",
      description:
        "QRコードアプリケーションでよく使用される機能コンポーネントは、異なるニーズに合わせて柔軟に組み合わせることができます。",
    },
  },
  {
    locale: "zh",
    data: {
      title: "QR市场的<span class='down-mark-line'>组成部分</span>",
      description: "QR码应用程序中常用的功能组件可以灵活组合以适应不同的需求。",
    },
  },
  {
    locale: "nl",
    data: {
      title: "QR Marketing <span class='down-mark-line'>Componenten</span>",
      description:
        "Functionele componenten die vaak worden gebruikt in QR-code-toepassingen, kunnen flexibel worden samengesteld om aan verschillende behoeften te voldoen.",
    },
  },
  {
    locale: "de",
    data: {
      title: "QR-Marketing-<span class='down-mark-line'>Komponenten</span>",
      description:
        "Funktionale Komponenten, die häufig in QR-Code-Anwendungen verwendet werden, können flexibel zusammengestellt werden, um unterschiedlichen Anforderungen gerecht zu werden.",
    },
  },
  {
    locale: "fr",
    data: {
      title:
        "Les <span class='down-mark-line'>Composants</span> du Marketing QR",
      description:
        "Les composants fonctionnels couramment utilisés dans les applications de codes QR peuvent être assemblés de manière flexible pour répondre à différents besoins.",
    },
  },
  {
    locale: "es",
    data: {
      title: "Componentes del marketing <span class='down-mark-line'>QR</span>",
      description:
        "Los componentes funcionales comúnmente utilizados en aplicaciones de código QR se pueden ensamblar de manera flexible para adaptarse a diferentes necesidades.",
    },
  },
  {
    locale: "it",
    data: {
      title: "<span class='down-mark-line'>Componenti</span> del Marketing QR",
      description:
        "I componenti funzionali comunemente utilizzati nelle applicazioni di codice QR possono essere assemblati in modo flessibile per soddisfare diverse esigenze.",
    },
  },
  {
    locale: "pt",
    data: {
      title: "Componentes de <span class='down-mark-line'>Marketing</span> QR",
      description:
        "Componentes funcionais comumente usados em aplicações de código QR podem ser montados de forma flexível para atender a diferentes necessidades.",
    },
  },
];

const dataLocales: Array<Functional> = [
  {
    locale: "en",
    data: [
      {
        title: "Content display",
        description:
          "There is a flexible combination of content that can be modified as needed. The layout supports a mixture of graphic and text multimedia.",
      },
      {
        title: "Data management",
        description:
          "We provide custom forms and states, files, as well as data summary management and a statistical graph",
      },
      {
        title: "Cooperation",
        description:
          "Our cooperation features include cycle planning and notification, membership and permissions, as well as notifications and closed-loop collaboration.",
      },

      {
        title: "One-size",
        description:
          "We also offer a one-size-fits-all solution for batch production and management, typography style beautification, and an on-demand printing service.",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        title: "コンテンツ表示",
        description:
          "必要に応じて修正できる柔軟なコンテンツの組み合わせがあります。レイアウトは、グラフィックとテキストのマルチメディアを混在させることができます。",
      },
      {
        title: "データ管理",
        description:
          "カスタムフォームとステート、ファイル、データサマリー管理、統計グラフなどを提供しています。",
      },
      {
        title: "協力",
        description:
          "サイクル計画と通知、メンバーシップと権限、通知とクローズドループのコラボレーションなど、協力機能を提供しています。",
      },
      {
        title: "ワンサイズ",
        description:
          "バッチ生産と管理、タイポグラフィスタイルの美化、オンデマンド印刷サービスのワンサイズに対応したソリューションも提供しています。",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        title: "内容展示",
        description:
          "有灵活的内容组合，可以根据需要进行修改。布局支持图形和文本多媒体的混合。",
      },
      {
        title: "数据管理",
        description:
          "我们提供定制的表单和状态、文件，以及数据摘要管理和统计图表。",
      },
      {
        title: "合作",
        description:
          "我们的合作功能包括循环计划和通知、会员和权限，以及通知和闭环协作。",
      },
      {
        title: "通用解决方案",
        description:
          "我们还提供适用于批量生产和管理、字体风格美化以及按需打印服务的通用解决方案。",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        title: "Exibição de conteúdo",
        description:
          "Há uma combinação flexível de conteúdo que pode ser modificada conforme necessário. O layout suporta uma mistura de multimídia gráfica e de texto.",
      },
      {
        title: "Gerenciamento de dados",
        description:
          "Oferecemos formulários e estados personalizados, arquivos, bem como gerenciamento de resumo de dados e um gráfico estatístico.",
      },
      {
        title: "Cooperação",
        description:
          "Nossos recursos de cooperação incluem planejamento e notificação de ciclo, associação e permissões, bem como notificações e colaboração em loop fechado.",
      },
      {
        title: "Tamanho único",
        description:
          "Também oferecemos uma solução única para produção e gerenciamento em massa, embelezamento de estilo tipográfico e um serviço de impressão sob demanda.",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        title: "Hiển thị nội dung",
        description:
          "Có sự kết hợp linh hoạt giữa các nội dung có thể được điều chỉnh theo nhu cầu. Bố cục hỗ trợ sự pha trộn đa phương tiện đồ họa và văn bản.",
      },
      {
        title: "Quản lý dữ liệu",
        description:
          "Chúng tôi cung cấp các biểu mẫu và trạng thái tùy chỉnh, tệp tin, cũng như quản lý tóm tắt dữ liệu và một biểu đồ thống kê.",
      },
      {
        title: "Làm việc nhóm",
        description:
          "Các tính năng nhóm của chúng tôi bao gồm kế hoạch chu kỳ và thông báo, thành viên và phân quyền, cũng như thông báo và hợp tác lặp lại vòng.",
      },
      {
        title: "Một kích thước",
        description:
          "Chúng tôi cũng cung cấp một giải pháp phù hợp với sản xuất và quản lý theo lô, làm đẹp kiểu chữ và dịch vụ in theo yêu cầu.",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        title: "Anzeige von Inhalten",
        description:
          "Es gibt eine flexible Kombination von Inhalten, die bei Bedarf modifiziert werden kann. Das Layout unterstützt eine Mischung aus Grafiken und Text-Multimedia.",
      },
      {
        title: "Datenmanagement",
        description:
          "Wir bieten benutzerdefinierte Formulare und Zustände, Dateien sowie Datenzusammenfassungs-Management und einen statistischen Graphen.",
      },
      {
        title: "Zusammenarbeit",
        description:
          "Unsere Zusammenarbeitsfunktionen umfassen Zyklusplanung und Benachrichtigung, Mitgliedschaft und Berechtigungen sowie Benachrichtigungen und geschlossene Zusammenarbeit.",
      },
      {
        title: "One-size",
        description:
          "Wir bieten auch eine Einheitslösung für die Chargenproduktion und -verwaltung, die Verschönerung von Typografie-Stilen sowie einen On-Demand-Druckservice.",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        title: "Affichage de contenu",
        description:
          "Il y a une combinaison flexible de contenu qui peut être modifiée selon les besoins. La mise en page prend en charge un mélange de multimédia graphique et textuel.",
      },
      {
        title: "Gestion des données",
        description:
          "Nous proposons des formulaires et des états personnalisés, des fichiers, ainsi que la gestion de résumés de données et un graphique statistique.",
      },
      {
        title: "Collaboration",
        description:
          "Nos fonctionnalités de collaboration incluent la planification et la notification du cycle, l'adhésion et les autorisations, ainsi que les notifications et la collaboration en boucle fermée.",
      },
      {
        title: "Taille unique",
        description:
          "Nous offrons également une solution taille unique pour la production et la gestion en lots, l'embellissement des styles de typographie, ainsi qu'un service d'impression à la demande.",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        title: "Visualizzazione dei contenuti",
        description:
          "C'è una combinazione flessibile di contenuti che può essere modificata a seconda delle esigenze. Il layout supporta una miscela di multimedia grafici e testuali.",
      },
      {
        title: "Gestione dei dati",
        description:
          "Forniamo moduli e stati personalizzati, file, nonché gestione del riassunto dei dati e un grafico statistico.",
      },
      {
        title: "Collaborazione",
        description:
          "Le nostre funzionalità di collaborazione includono la pianificazione e la notifica del ciclo, l'appartenenza e le autorizzazioni, nonché le notifiche e la collaborazione a ciclo chiuso.",
      },
      {
        title: "Taglia unica",
        description:
          "Offriamo anche una soluzione taglia unica per la produzione e la gestione in batch, l'abbellimento degli stili tipografici e un servizio di stampa on-demand.",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        title: "Weergave van inhoud",
        description:
          "Er is een flexibele combinatie van inhoud die indien nodig kan worden aangepast. De lay-out ondersteunt een mix van grafische en tekstuele multimedia.",
      },
      {
        title: "Gegevensbeheer",
        description:
          "We bieden op maat gemaakte formulieren en toestanden, bestanden, evenals gegevenssamenvatting beheer en een statistische grafiek.",
      },
      {
        title: "Samenwerking",
        description:
          "Onze samenwerkingsfuncties omvatten cyclische planning en melding, lidmaatschap en machtigingen, evenals meldingen en gesloten-lus samenwerking.",
      },
      {
        title: "One-size",
        description:
          "We bieden ook een one-size-fits-all oplossing voor batchproductie en -beheer, typografische stijlverfraaiing en een on-demand printservice.",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        title: "Visualización de contenido",
        description:
          "Existe una combinación flexible de contenido que se puede modificar según sea necesario. El diseño admite una mezcla de multimedia gráfica y de texto.",
      },
      {
        title: "Gestión de datos",
        description:
          "Ofrecemos formularios y estados personalizados, archivos, así como gestión de resumen de datos y un gráfico estadístico.",
      },
      {
        title: "Colaboración",
        description:
          "Nuestras funciones de colaboración incluyen planificación y notificación cíclicas, membresía y permisos, así como notificaciones y colaboración en bucle cerrado.",
      },
      {
        title: "Tamaño único",
        description:
          "También ofrecemos una solución universal para la producción y gestión en lotes, embellecimiento del estilo tipográfico y un servicio de impresión a pedido.",
      },
    ],
  },
];
